module.exports = __webpack_public_path__ + "static/media/add-widget-button.893a7a36.svg";